import { render, staticRenderFns } from "./ProductTypeDialog.vue?vue&type=template&id=5005789c&scoped=true"
import script from "./ProductTypeDialog.vue?vue&type=script&lang=js"
export * from "./ProductTypeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5005789c",
  null
  
)

export default component.exports